var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubarao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a6e75",
    d: "M73 73h204v204H73z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 277c6-8 12-14 20-20l-16 6 6-9c-5 3-21 11-16 5 4-5 2-12 1-17-1-4 10-25 20-5h3c6-6 9 5 7 13 19-3 19-21 27-22 1 19 8 20 33-3-2 6-1 9-7 18 2-1 4-2 7-1 7-3 7 0 7 5-7 0-3 5-11 5-3 0-5 2-8 5l4-12c-9 8-20 24-22 17-7-19-26 4-34 9l-1-5-15 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 277c20-24 25-15 19 0Zm70-11c16-26 22-11 17-5-7 9 0-12-17 5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 257c28-18 47-60 45-97-7 2-16 3-22 2-11 23-33 20-35 1-11-6-13-30 2-40-2-19 11-46 31-49 8-17 43-30 80-15 40-19 111 43 115 92 8 3 12 17 8 25 8 19-2 46-9 58l-2-11c-9 22-12 29-26 54h-8c16-26 24-69 17-86-18 4-4 37-35 71l3-13c-6 0-12 17-21 28h-8c19-22 27-47 31-71-15-3-15 17-27 36-6 11-4-11-12 2-5 9-10 19-25 29 9-13 29-37 29-61-9-9-11 28-41 47 7-9 16-21 21-34-11 13-14-9-12-24-6-2-14 36-73 76h-7c35-25 63-74 60-90-6 10-12 19-19 27 20-43 9-56 5-50-14 21-25 81-65 97Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89 161c-10 22-25 8-24-4-11-10-4-28 3-29 0-23 13-42 28-47 0 12 12 20 23 19-42-23 16-54 54-32 54-11 94 37 106 67-6-3-9-3-14 0-2-7-10-11-17-11-15-12-36-8-47-2 12 14-6 25-14 6-9 11 0 16 9 19-15 12-33-3-29-14-37-5-15-45 36-34 23-5 34 2 42 9 1-11-16-18-41-16-48-10-69 10-74 17-8 1-9 8-8 11 2 4-9 5-15-3-1 11 14 19 26 11 5 4 5 30-21 18-1 3 0 5 3 8-15 0-36-15-30-33-2-7-1-14 2-20-9 5-9 14-7 20-9 17 4 29 9 31s-2 8-13 4c0 5 7 6 13 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 153c-23-22 32-35 42-10 15-9 23 6 21 14 5 2 6 9 5 13 3 6 0 15-3 18-3-21-18-31-23-31s-11 9-16 9c-6 0-8-9-15-9-6 0-6 4-5 5 4 4 1 5-3 5s-12-8-3-14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubarao);
export default __webpack_public_path__ + "static/media/tubarao.0719747d52a5c0504744b71beb126f71.svg";
export { ForwardRef as ReactComponent };